import { moveItemInArray, CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, AfterViewChecked, OnInit } from '@angular/core';
import { IItemsMovedEvent, IListBoxItem } from './dual-list-box';
import { FormBuilder, FormGroup } from '@angular/forms';
import { element } from '@angular/core/src/render3';
import { NzNotificationService } from 'ng-zorro-antd';

@Component({
  selector: 'app-drag-drop-dual-list',
  templateUrl: './drag-drop-dual-list.component.html',
  styleUrls: ['./drag-drop-dual-list.component.css'],
})
export class DragDropDualListComponent implements OnInit{

// array of items to display in left box
  @Input() set availables(items: Array<{}>) {
    this.availableItems = [...(items || []).map((item: {}, index: number) => ({
      value: item[this.valueField].toString(),
      text: item[this.textField],
    }))];
    this.availableItemsCopy = [...(items || []).map((item: {}, index: number) => ({
      value: item[this.valueField].toString(),
      text: item[this.textField],
    }))];
  }
// array of items to display in right box
  @Input() set selects(items: Array<{}>) {
    this.selectedItems = [...(items || []).map((item: {}, index: number) => ({
      value: item[this.valueField].toString(),
      text: item[this.textField],
    }))];

    // this.selectedItemsCopy = [...(items || []).map((item: {}, index: number) => ({
    //   value: item[this.valueField].toString(),
    //   text: item[this.textField],
    // }))];
    this.selectedItemsCopy = this.selectedItems;
  }
// fiield to use for value of option
@Input() valueField = 'id';
// field to use for displaying option text
@Input() textField = 'name';
// text displayed over the available items list box
@Input() availableText = 'No seleccionados';
// text displayed over the selected items list box
@Input() selectedText = 'Seleccionados';
// set placeholder text in available items list box
@Input() availableFilterPlaceholder = 'Filtrar';
// set placeholder text in selected items list box
@Input() selectedFilterPlaceholder = 'Filtrar';

// event called when items are moved between boxes, returns state of both boxes and item moved
@Output() itemsMoved: EventEmitter<IItemsMovedEvent> = new EventEmitter<IItemsMovedEvent>();
// event called when items are click left box
@Output() itemsClickLeft: EventEmitter<IItemsMovedEvent> = new EventEmitter<IItemsMovedEvent>();

@Input() maxSelectedItems: number = Number.MAX_SAFE_INTEGER;

availableItems: Array<IListBoxItem> = [];
availableItemsCopy: Array<IListBoxItem> = [];
itemsFiltro = [];
selectedItems: Array<IListBoxItem> = [];
selectedItemsCopy: Array<IListBoxItem> = [];
listBoxForm: FormGroup;

  private  copySelected: any;
  public wordFilter: any;

constructor(public fb: FormBuilder, private notification: NzNotificationService) {


this.listBoxForm = this.fb.group({
availableSearchInput: [''],
selectedSearchInput: [''],
});
}

ngOnInit(): void {
    this.availableItems.sort((o1, o2) => Intl.Collator().compare(o1.text.toLowerCase(), o2.text.toLowerCase()));
}

//     ngAfterViewChecked(): void {
// }

drop(event: CdkDragDrop<IListBoxItem[]>) {
  // console.log('drop de geocercas:', event);
  if (event.container.data === this.selectedItems &&
    this.maxSelectedItems && this.selectedItems.length >= this.maxSelectedItems) {
    this.createNotification('warning', 'Error en el formulario',
      `Solo puedes agregar ${this.maxSelectedItems} como máximo`);
    return;
  }

  if (event.previousContainer === event.container) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }
  // else {
  //   // if (this.wordFilter){
  //   //   let item = this.selectedItemsCopy[+event.previousIndex];
  //   //   this.selectedItemsCopy.splice(+event.previousIndex, 1 );
  //   //   this.availableItems.push({
  //   //     value: item.value.toString(),
  //   //     text: item.text.toString(),
  //   //   });
  //   //   // console.log('drop 2 item', item);
  //   // }
  //   // else{
  //     transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
  //   // }
  //
  // }
  this.itemsMoved.emit({
    available: this.availableItems,
    selected: this.selectedItems,
    movedItems: event.container.data.filter((v, i) => i === event.currentIndex),
    from: 'available',
    to: 'selected',
  });

}

  // drop2(event: CdkDragDrop<IListBoxItem[]>) {
  //   // console.log('drop 2:', event);
  //   if (event.previousContainer === event.container) {
  //     moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  //   }
  //   else {
  //
  //     if (this.wordFilter){
  //       let item = this.availableItems[+event.previousIndex];
  //       this.availableItems.splice(+event.previousIndex, 1 );
  //       this.selectedItemsCopy.push({
  //         value: item.value.toString(),
  //         text: item.text.toString(),
  //       });
  //       // console.log('drop 2 item', item);
  //     }
  //     else{
  //       transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
  //     }
  //
  //   }
  //     this.itemsMoved.emit({
  //     available: this.availableItems,
  //     selected: this.selectedItems,
  //     movedItems: event.container.data.filter((v, i) => i === event.currentIndex),
  //     from: 'available',
  //     to: 'selected',
  //   });
  // }

onKey2(event){
  let expr = new RegExp(event.target.value.toLowerCase() );
  let filtro = this.availableItemsCopy.filter((element) => {
      if (expr.test(element.text.toLowerCase())){
          return true;
      }
  });
  if (event.target.value === ''){
    this.availableItems = this.availableItemsCopy;
  }
  else{
   this.availableItems = filtro;
  }
  this.selectedItems.forEach((element) => {
    this.availableItems.forEach((dis, index2) => {
      if (dis.value === element.value){
        this.availableItems.splice(index2, 1 );
      }
    });
  });
}


  onKey3(event){
    let expr = new RegExp(event.target.value.toLowerCase() );
  this.wordFilter = event;
    let filtro = this.selectedItemsCopy.filter((element) => {
      if (expr.test(element.text.toLowerCase())){
        return true;
      }
    });
    if (event.target.value === ''){
      this.selectedItems = this.selectedItemsCopy;
    }
    else{
      this.selectedItems = filtro;
    }
    // this.availableItems.forEach((element) => {
    //   this.selectedItems.forEach((dis, index2) => {
    //     if (dis.value === element.value){
    //       this.selectedItems.splice(index2, 1 );
    //     }
    //   });
    // });
  }

  createNotification(type: string, title?: string, content?: string): void {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.notification.create(
      type,
      title,
      content,
      { nzAnimate: true }
    );
  }

  seleccionar(item ){
    // console.log(item);
    // debugger
     let seCambio:  boolean = false;

    if (this.maxSelectedItems && this.selectedItems.length >= this.maxSelectedItems) {
      this.createNotification('warning', 'Error en el formulario',
      `Solo puedes agregar ${this.maxSelectedItems} como máximo`);
            return;
    }


    if (this.wordFilter){
      if (this.selectedItems.length != 0){
        // this.wordFilter.target.value = '';
        this.wordFilter = null;
        this.selectedItems = this.selectedItemsCopy;
      }
    }

     if (!seCambio){
      this.availableItems.forEach(  (ele, index)  => {
        if (item.value === ele.value){
          this.availableItems.splice(index, 1);
          this.selectedItems.push({
            value: item.value.toString(),
            text: item.text.toString(),
          });
          // if (this.wordFilter.target.value){
          if (this.wordFilter){
            this.selectedItemsCopy.push({
              value: item.value.toString(),
              text: item.text.toString(),
            });
          }

        }
      });
     }

    this.itemsClickLeft.emit({
      available: this.availableItems,
      selected: this.selectedItems,
      movedItems: item,
      from: 'available',
      to: 'selected',
    });


    // console.log(item);
  }

  quitarSeleccion(item){
    let seCambio:  boolean = false;
    if (!seCambio){
      this.selectedItems.forEach(  (ele, index)  => {
        if (item.value === ele.value){
          this.selectedItems.splice(index, 1);
          this.availableItems.push({
            value: item.value.toString(),
            text: item.text.toString(),
          });

          // if (this.wordFilter.target) {
          if (this.wordFilter) {
            this.selectedItemsCopy.forEach(  (copy, index2)  => {
              if (item.value === copy.value){
                this.selectedItemsCopy.splice(index2, 1);
              }
            });
          }

        }
      });
    }
    // if (this.wordFilter.target.value) {
    //   this.availableItems.forEach((element) => {
    //     this.selectedItems.forEach((dis, index2) => {
    //       if (dis.value === element.value){
    //         this.selectedItems.splice(index2, 1 );
    //       }
    //     });
    //   });
    // }
    this.availableItems.sort((o1, o2) => Intl.Collator().compare(o1.text.toLowerCase(), o2.text.toLowerCase()));

    this.itemsClickLeft.emit({
      available: this.availableItems,
      selected: this.selectedItems,
      movedItems: item,
      from: 'selected',
      to: 'available',
    });
  }

}
